export default __webpack_public_path__ + "dgh.bb72d51b.png";